import React from 'react'
import { useSelector } from 'react-redux'
import { PulseLoader } from 'react-spinners'

const Notification = () => {

    const { response, error, loading } = useSelector((state) => state.getNotification)

    const getTimeAgo = (dateString) => {
        const now = new Date();
        const createdAt = new Date(dateString);
        const diffInSeconds = Math.floor((now - createdAt) / 1000);
        const diffInMinutes = Math.floor(diffInSeconds / 60);
        const diffInHours = Math.floor(diffInMinutes / 60);
        const diffInDays = Math.floor(diffInHours / 24);

        if (diffInSeconds < 60) {
            return `${diffInSeconds} second${diffInSeconds !== 1 ? 's' : ''} ago`;
        } else if (diffInMinutes < 60) {
            return `${diffInMinutes} minute${diffInMinutes !== 1 ? 's' : ''} ago`;
        } else if (diffInHours < 24) {
            return `${diffInHours} hour${diffInHours !== 1 ? 's' : ''} ago`;
        } else {
            return `${diffInDays} day${diffInDays !== 1 ? 's' : ''} ago`;
        }
    };
    return (
        loading
    ) ? (
        <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
            <PulseLoader size={25} color="#0f0a30" />
        </div>
    ) : error ? (
        <div style={{ height: '70vh' }} className='d-flex align-items-center justify-content-center'>
            <p className='text-danger'>Something went wrong</p>
        </div>
    ) :
        (
            <div className="content-wrapper">
                <section className="main-section notification-section spacer">
                    <div className="container">
                        <div className="row gy-3">
                            <div className="col-xl-12">
                                <div className="wrapper-card">
                                    {response?.data?.map((r, index) => {
                                        return (
                                            <div className="notification-card" key={index}>
                                                {/* <div className="ntf-user-profile">
                                                    <img src="/assets/images/user-02.png" alt="user" />
                                                </div> */}
                                                <div className="ntf-details">
                                                    {/* <h2 className="h6 fw-semibold">john Smith</h2> */}
                                                    <p>{r?.description}</p>
                                                </div>
                                                <span className="ntf-time">{getTimeAgo(r?.createdAt)}</span>
                                            </div>
                                        );
                                    })}


                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        )
}

export default Notification